<template>
  <div id="loading"></div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style lang="scss" scoped>
#loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #15191f url('~@/assets/img/loading.gif') 50% 50% / 300px auto no-repeat;
  opacity: 0.85;
  z-index: 99999;
}
</style>
